import {QLProvidersEnum} from "@/graphql/queries/ql/composables";

export enum ActiveProviders {
	MindBody = QLProvidersEnum.MindBody,
	Pike13 = QLProvidersEnum.Pike13,
	FitDegree = QLProvidersEnum.FitDegree,
	MarianaTek = QLProvidersEnum.MarianaTek,
}
